import { get } from 'js-cookie';

type SessionCookie = {
	sessionId: string;
	hideToastNotification: boolean;
	liveChatAutoDisconnectNoticeReceivedTimestamp?: number;
	liveChatAutoDisconnectNoticeDismissedTimestamp?: number;
	lastInteractionTimestamp?: number;
};

export function getChatbotSessionCookie(): SessionCookie | undefined {
	const chatbotSessionCookie = get('ChatbotSession');

	if (!chatbotSessionCookie) {
		// eslint-disable-next-line no-undefined
		return undefined;
	}

	return JSON.parse(chatbotSessionCookie);
}

export function lastChatbotInteractionWithin(timePeriod: number): boolean {
	// TODO: If chatbot was opened more than X days ago, we don't want
	// to retrieve the remote session because it will be stale anyway.

	const chatbotSessionCookie = getChatbotSessionCookie();

	if (!chatbotSessionCookie) {
		return false;
	}

	if (
		chatbotSessionCookie.lastInteractionTimestamp &&
		Date.now() - chatbotSessionCookie.lastInteractionTimestamp < timePeriod
	) {
		return true;
	}

	return false;
}
